<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card title="Historico de tareas">
        <template slot="actions">
          <feather-icon
            icon="SettingsIcon"
            svgClasses="w-6 h-6 text-grey"
          ></feather-icon>
        </template>
        <div class="vx-row">
          <div class="vx-col w-full ">
            <vs-divider></vs-divider>

            
            <div v-if="arrTareas.length == 0" class="mb-4" style="display: grid;place-items: center;">
              <img src="../../../assets/images/logo/not-found.png" alt="" style="width: 15rem;">
              <p class="mt-4">No existen tareas asignadas.</p>
            </div>



            <div v-else
              style="background-color: #f7f7f7;padding: 8px 8px 8px 8px;"
              class="mb-4"
              v-for="tarea in arrTareas"
              :key="tarea.idTarea"
            >

                <div class="vx-row">
                    <div class="vx-col">
                      <i
                        class="vs-icon notranslate icon-scale material-icons null"
                        style="font-size: 34px; text-align: left;color: #3c77a5;margin-top: 2px;"
                        >assignment
                      </i>
                    </div>
                    
                    <div class="vx-col w-full md:w-3/4">

                            <p style="font-size: 12px;font-weight: bold;color: #28c76f;">
                              Fecha de entrega: <span>{{ tarea.fechaEntrega }}</span>
                            </p>
                            <p>
                              <router-link
                                style="border-bottom: 1px solid;color: #3c4858;font-family: arial;text-decoration: none;font-size: 14px;font-weight: bold;"
                                :to="'/detalle-tarea/' + tarea.idTarea"
                              >
                                {{ tarea.nombreTarea }}
                              </router-link>
                            </p>
                    </div>

                    <div class="vx-col w-full ">
                             <p
                              v-if="tarea.fechaTareaEntregada != ''"
                              class="text-right"
                              style="font-weight: bold;color: #3c77a5;"
                            >
                              Entregada el día: {{ tarea.fechaTareaEntregada }}
                            </p>
                            <p
                              v-else
                              class="text-right"
                              style="font-weight: bold;font-size: 12px;color: red;"
                            >
                              Sin entregar
                            </p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
const $ = require("jquery");
export default {
  data() {
    return {
      idAsignatura:'',
      arrTareas: [],
    };
  },

  methods: {
    getTasks(idAsignatura) {
      fetch(`${this.$BASE.baseUrl}api/tareasHistoricas/${idAsignatura}`, {
        method: "GET",
        headers: {
          Authorization: sessionStorage.getItem("token"),
        },
      })
        .then((rs) => rs.json())
        .catch((error) => console.log("error: ", error))
        .then((rs) => {
          if (rs.status === 200) {
            this.arrTareas = rs.result;
          }
        });
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  created() {
    this.idAsignatura = this.$route.params.idAsignatura;
    this.getTasks(this.idAsignatura);
  },
};
</script>
